import React from 'react';
import {useIntl} from 'react-intl';
import {dispatch, EVENT_ID} from '../../../../containers/event_manager';
import {anchorElementId, novaInstanceKey, NovaAgentPicker} from './NovaAgentPicker';
import {showChangeAgentConfirmationModal} from './modals/ChangeAgentConfirmationModal';
import {NovaCompactButton} from './NovaCompactButton';

export interface ChangeAgentAffordanceProps {
	taskId: string;
	// See NovaAgentPickerProps.instanceKey (NovaAgentPicker.tsx).
	instanceKey?: string;
	currentAgentId: string;
	hasReplies: boolean;
	onAgentChanged: (newAgentId: string) => void;
	// Shown, but refused, with the reason on it — changing the agent starts a fresh run, so it
	// needs the same permission acting on the task needs.
	disabled?: boolean;
	disabledReason?: string;
}

export const ChangeAgentAffordance = (props: ChangeAgentAffordanceProps): JSX.Element => {
	const {formatMessage} = useIntl();

	const handleSelect = (selectedAgentId: string): void => {
		if (selectedAgentId === props.currentAgentId) return;
		if (props.hasReplies) {
			showChangeAgentConfirmationModal({onConfirm: () => props.onAgentChanged(selectedAgentId)});
		} else {
			props.onAgentChanged(selectedAgentId);
		}
	};

	return (
		<>
			{/* The same compact outlined control the answer card's other actions use, in its neutral
			    tone: changing the agent is not the card's primary act, and a text link among three
			    bordered buttons reads as a different kind of thing than it is. */}
			<NovaCompactButton
				tone="neutral"
				onPress={() => dispatch(EVENT_ID.NOVA_TOGGLE_PICKER, novaInstanceKey(props.taskId, props.instanceKey))}
				disabled={props.disabled}
				title={props.disabled ? props.disabledReason : undefined}
				data-cy="nova-change-agent"
				id={anchorElementId(props.taskId, props.instanceKey)}
			>
				{formatMessage({id: 'nova_invocation.change_agent.button'})}
			</NovaCompactButton>
			<NovaAgentPicker taskId={props.taskId} instanceKey={props.instanceKey} onSelectAgent={handleSelect} />
		</>
	);
};
